import DriverMedals from "../../../views/DriverMedals";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const DriverMedalsRoutes = [
  {
    menuName: MenuNames.DRIVER_MEDALS,
    path: "/driver-medals",
    component: DriverMedals,
    exact: true,
  },
];

export default DriverMedalsRoutes;
